export default __webpack_public_path__ + "static/media/annotation.7ce28f5f.svg";